// src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import "@ant-design/v5-patch-for-react-19"; // React 19 compatibility patch
import App from "./App";
import "antd/dist/reset.css"; // Ant Design reset CSS
import "./index.css"; // Global styles

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
